export default "__VITE_ASSET__LuFYW1b___"